import { useRef, useState } from "react";

const CourseListDetails = [
  {
    type: "short",
    courses: [
      {
        name: "icap",
        title:
          "Introduction to Computer Application Packages and Unicode Bangla (ICAP)",
      },

      {
        name: "gdm",
        title: "Professional Course on Graphics Design & Multimedia (GDM)",
      },

      {
        name: "cdm",
        title: "Professional Course on Digital Marketing (CDM)",
      },
    ],
  },

  {
    type: "long",
    courses: [
      {
        name: "dict",
        title: "Diploma in Information and Communication Technology (DICT)",
      },
    ],
  },
];

const BatchListDetails = [
  {
    name: "icap",
    batches: [179, 180, 181],
  },

  {
    name: "gdm",
    batches: [1],
  },

  {
    name: "cdm",
    batches: [1],
  },

  {
    name: "dict",
    batches: [23, 24],
  },
];

const Form = () => {
  const [uploading, setUploading] = useState(false);
  const [photoUrl, setPhotoUrl] = useState("");

  const [formData, setFormData] = useState({
    courseType: "",
    course: "",
    batch: "",
    fullName: "",
    dateOfBirth: "",
    photo: "",
    fatherName: "",
    motherName: "",
    gender: "",
    email: "",
    contact: "",
    id: "",
    guardianContact: "",
    occupation: "",
    designation: "",
    organization: "",
    workingSector: "",
    district: "",
    lastEducationQualification: "",
    permanentAddress: "",
    presentAddress: "",
  });

  const [courseList, setCourseList] = useState([]);
  const [batchList, setBatchList] = useState([]);

  const courseListRef = useRef(null);
  const batchListRef = useRef(null);
  const formRef = useRef(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePhotoChange = (e) => {
    const photo = e.target.files[0];

    // check if photo is selected
    if (!photo) return;

    // check if photo extension is jpg, jpeg or png and size is less than equal 300kb
    const photoExtension = photo.name.split(".").pop();
    const photoSize = photo.size / 1024;
    if (!["jpg", "jpeg", "png"].includes(photoExtension) || photoSize >= 300) {
      alert(
        `Please upload a photo with jpg, jpeg or png extension and size no more than 300KB`
      );

      e.target.value = null;
      setPhotoUrl("");

      return;
    }

    // set photo url
    const photoUrl = URL.createObjectURL(photo);
    setPhotoUrl(photoUrl);

    setFormData({ ...formData, photo: e.target.files[0] });
  };

  const handleTypeChange = (event) => {
    handleChange(event);

    const { value } = event.target;

    const selectedCourseList = CourseListDetails.find(
      ({ type }) => type === value
    );

    setCourseList(selectedCourseList?.courses || []);

    courseListRef.current.value = "";
  };

  const handleCourseChange = (event) => {
    handleChange(event);

    const { value } = event.target;

    const selectedBatchList = BatchListDetails.find(
      ({ name }) => name === value
    );

    setBatchList(selectedBatchList?.batches || []);

    batchListRef.current.value = "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (uploading) return;

    function verify() {
      const result = {
        status: true,
        message: "",
      };

      // check if fullName, Contact, id, district, courseType, course, batch is not empty
      const requiredFields = [
        { label: "fullName", name: "Full Name" },
        { label: "contact", name: "Contact" },
        { label: "id", name: "ID" },
        { label: "district", name: "District" },
        { label: "courseType", name: "Course Type" },
        { label: "course", name: "Course" },
        { label: "batch", name: "Batch" },
      ];

      for (const { label, name } of requiredFields) {
        if (!formData[label]) {
          result.status = false;
          result.message = `Please enter ${name}`;
          return result;
        }
      }

      // check if email is valid
      if (formData.email) {
        const emailRegex = /\S+@\S+\.\S+/;
        if (!emailRegex.test(formData.email)) {
          result.status = false;
          result.message = `Please enter a valid email address`;
          return result;
        }
      }

      // check if course type is from course list details
      const courseType = CourseListDetails.find(
        ({ type }) => type === formData.courseType
      );
      if (!courseType) {
        result.status = false;
        result.message = `Please select a valid course type`;
        return result;
      }

      // check if course is from course list details
      const course = courseType.courses.find(
        ({ name }) => name === formData.course
      );
      if (!course) {
        result.status = false;
        result.message = `Please select a valid course`;
        return result;
      }

      // check if batch is from batch list details
      const batch = BatchListDetails.find(({ batches }) =>
        batches.includes(Number(formData.batch))
      );
      if (!batch) {
        result.status = false;
        result.message = `Please select a valid batch`;
        return result;
      }

      // check if contact is valid
      const contactRegex = /^(?:\+?88|0088)?01[15-9]\d{8}$/;
      if (!contactRegex.test(formData.contact)) {
        result.status = false;
        result.message = `Please enter a valid contact number`;
        return result;
      }

      // check if guardian contact is valid
      if (formData.guardianContact) {
        if (!contactRegex.test(formData.guardianContact)) {
          result.status = false;
          result.message = `Please enter a valid guardian contact number`;
          return result;
        }
      }

      // check if gender is M/F only
      if (formData.gender) {
        const validGender = ["male", "female"];
        if (!validGender.includes(formData.gender.toLowerCase())) {
          result.status = false;
          result.message = `Please select a valid gender`;
          return result;
        }
      }

      // check if working sector is valid
      if (formData.workingSector) {
        const validWorkingSector = ["govt", "private", "other"];
        if (
          !validWorkingSector.includes(formData.workingSector.toLowerCase())
        ) {
          result.status = false;
          result.message = `Please select a valid working sector`;
          return result;
        }
      }

      return result;
    }

    const { status, message } = verify();

    if (!status) {
      message && alert(message);
      return;
    }

    const confirm = window.confirm(`Are you sure about all the entered info?`);

    if (!confirm) return;

    try {
      setUploading(true);

      const { app, db } = await import("../firebase/firebase-init");

      let photoUrl = "";

      // upload photo to storage, if photo is available
      if (formData.photo instanceof File) {
        const photoName = `${formData.photo.name}_${new Date().getTime()}`;

        const { getStorage, ref, uploadBytes } = await import(
          "firebase/storage"
        );

        const storage = getStorage(app);
        const userImageRef = ref(storage, photoName);

        await uploadBytes(userImageRef, formData.photo);

        const { getDownloadURL } = await import("firebase/storage");

        photoUrl = await getDownloadURL(userImageRef);
      }

      const { addDoc, collection } = await import("firebase/firestore/lite");

      const { uid } = await import("../helpers/uid");

      const storableData = {
        ...formData,
        photo: photoUrl,
        applicationID: uid(6),
      };

      const filteredStorableData = Object.fromEntries(
        Object.entries(storableData).filter(
          ([_, value]) => value !== "" && value !== null && value !== undefined
        )
      );

      await addDoc(collection(db, "applications"), filteredStorableData);

      const { default: Swal } = await import("sweetalert2");

      Swal.fire({
        icon: "success",
        title: "Application Submitted Successfully",
        html: `Your application ID is <b class="bg-secondary-subtle rounded-1 px-2">${storableData.applicationID}</b><br/>Please keep it safe for future reference`,
        confirmButtonText: "OK",
      });

      formRef.current.reset();
    } catch (error) {
      console.log(error);
    } finally {
      setUploading(false);
    }
  };

  return (
    <form
      ref={formRef}
      className="container mt-4"
      onSubmit={handleSubmit}>
      <div className="border bg-light rounded-1 overflow-hidden shadow-sm">
        <h5 className="bg-primary bg-gradient text-white mb-0 p-2 px-3">
          Course Details
        </h5>

        <div className="row gy-3 p-4">
          <div className="col-sm-6 col-md-3">
            <label
              className="mb-1"
              htmlFor="center">
              Select Center*
            </label>

            <select
              className="form-select border-secondary-subtle rounded-1 text-capitalize"
              defaultValue={``}
              id="center"
              name="center"
              required>
              <option
                className="text-capitalize"
                disabled
                value="">
                Select center
              </option>

              <option value="bccCtg">BCC Chattogram</option>
            </select>
          </div>

          <div className="col-sm-6 col-md-3">
            <label
              className="mb-1"
              htmlFor="courseType">
              Course Type*
            </label>

            <select
              onChange={handleTypeChange}
              className="form-select border-secondary-subtle rounded-1 text-capitalize"
              defaultValue={``}
              id="courseType"
              name="courseType"
              required>
              <option
                className="text-capitalize"
                disabled
                value="">
                Select type
              </option>

              <option value="long">Long Course</option>
              <option value="short">Short Course</option>
            </select>
          </div>

          <div className="col-sm-6 col-md-3">
            <label
              className="mb-1"
              htmlFor="course">
              Select Course*
            </label>

            <select
              ref={courseListRef}
              onChange={handleCourseChange}
              className="form-select border-secondary-subtle rounded-1 text-capitalize"
              defaultValue={``}
              id="course"
              name="course"
              required>
              <option
                className="text-capitalize"
                disabled
                value="">
                Select course
              </option>

              {courseList.map(({ name, title }, index) => (
                <option
                  key={index}
                  className="text-capitalize"
                  value={name}>
                  {title}
                </option>
              ))}
            </select>
          </div>

          <div className="col-sm-6 col-md-3">
            <label
              className="mb-1"
              htmlFor="batch">
              Batch Number*
            </label>

            <select
              onChange={handleChange}
              ref={batchListRef}
              className="form-select border-secondary-subtle rounded-1 text-capitalize"
              defaultValue={``}
              id="batch"
              name="batch"
              required>
              <option
                className="text-capitalize"
                disabled
                value="">
                Select Batch
              </option>

              {batchList.map((batch, index) => (
                <option
                  key={index}
                  className="text-capitalize"
                  value={batch}>
                  {batch}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <div className="border bg-light rounded-1 overflow-hidden shadow-sm mt-4">
        <h5 className="bg-primary bg-gradient text-white mb-0 p-2 px-3">
          Applicant Details
        </h5>

        <div className="px-4 pb-4">
          <div className="row">
            <div className="col-sm-6 col-md-4 mt-4">
              <label
                className="mb-1"
                htmlFor="fullName">
                Full Name*
              </label>

              <input
                type="text"
                className="form-control border-secondary-subtle rounded-1"
                id="fullName"
                name="fullName"
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-sm-6 col-md-4 mt-4">
              <label
                className="mb-1"
                htmlFor="dateOfBirth">
                Date of Birth
              </label>

              <input
                type="date"
                className="form-control border-secondary-subtle rounded-1"
                id="dateOfBirth"
                name="dateOfBirth"
                onChange={handleChange}
              />
            </div>

            <div className="col-sm-12 col-md-4 mt-4">
              {photoUrl && (
                <img
                  className="mb-1 object-fit-contain"
                  src={photoUrl}
                  width={200}
                  height={200}
                  alt=""
                />
              )}

              <div>
                <label
                  className="mb-1"
                  htmlFor="photo">
                  Photo
                </label>

                <input
                  type="file"
                  accept="image/*"
                  alt="photo"
                  onChange={handlePhotoChange}
                  className="form-control border-secondary-subtle rounded-1"
                  id="photo"
                  name="photo"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6 col-md-4 mt-4">
              <label
                className="mb-1"
                htmlFor="fatherName">
                Father's Name
              </label>

              <input
                type="text"
                className="form-control border-secondary-subtle rounded-1"
                id="fatherName"
                name="fatherName"
                onChange={handleChange}
              />
            </div>

            <div className="col-sm-6 col-md-4 mt-4">
              <label
                className="mb-1"
                htmlFor="motherName">
                Mother's Name
              </label>

              <input
                type="text"
                className="form-control border-secondary-subtle rounded-1"
                id="motherName"
                name="motherName"
                onChange={handleChange}
              />
            </div>

            <div className="col-md-4 mt-4">
              <label
                className="mb-1"
                htmlFor="gender">
                Gender
              </label>

              <select
                onChange={handleChange}
                className="form-select border-secondary-subtle rounded-1 text-capitalize"
                defaultValue={``}
                id="gender"
                name="gender">
                <option
                  className="text-capitalize"
                  disabled
                  value="">
                  Select gender
                </option>

                <option value="male">Male</option>
                <option value="female">Female</option>
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6 col-md-3 mt-4">
              <label
                className="mb-1"
                htmlFor="email">
                Email
              </label>

              <input
                type="email"
                className="form-control border-secondary-subtle rounded-1"
                id="email"
                name="email"
                onChange={handleChange}
              />
            </div>

            <div className="col-sm-6 col-md-3 mt-4">
              <label
                className="mb-1"
                htmlFor="contact">
                Contact*
              </label>

              <input
                type="tel"
                className="form-control border-secondary-subtle rounded-1"
                id="contact"
                name="contact"
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-sm-6 col-md-3 mt-4">
              <label
                className="mb-1"
                htmlFor="id">
                ID (NID/Birth Reg. No)*
              </label>

              <input
                type="number"
                className="form-control border-secondary-subtle rounded-1"
                id="id"
                name="id"
                placeholder="NID/Birth Reg. No"
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-sm-6 col-md-3 mt-4">
              <label
                className="mb-1"
                htmlFor="guardianContact">
                Guardian Contact No.
              </label>

              <input
                type="tel"
                className="form-control border-secondary-subtle rounded-1"
                id="guardianContact"
                name="guardianContact"
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6 mt-4">
              <label
                className="mb-1"
                htmlFor="occupation">
                Occupation
              </label>

              <input
                type="text"
                className="form-control border-secondary-subtle rounded-1"
                id="occupation"
                name="occupation"
                onChange={handleChange}
              />
            </div>

            <div className="col-sm-6 mt-4">
              <label
                className="mb-1"
                htmlFor="designation">
                Designation
              </label>

              <input
                type="text"
                className="form-control border-secondary-subtle rounded-1"
                id="designation"
                name="designation"
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-6 mt-4">
              <label
                className="mb-1"
                htmlFor="organization">
                Organization
              </label>

              <input
                type="text"
                className="form-control border-secondary-subtle rounded-1"
                id="organization"
                name="organization"
                onChange={handleChange}
              />
            </div>

            <div className="col-sm-6 mt-4">
              <label
                className="mb-1"
                htmlFor="workingSector">
                Working Sector
              </label>

              <select
                onChange={handleChange}
                className="form-select border-secondary-subtle rounded-1 text-capitalize"
                defaultValue={``}
                id="workingSector"
                name="workingSector">
                <option
                  className="text-capitalize"
                  disabled
                  value="">
                  Select working sector
                </option>

                <option value="govt">Government</option>
                <option value="private">Private</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="mt-4">
            <label
              className="mb-1"
              htmlFor="district">
              District*
            </label>

            <input
              type="text"
              className="form-control border-secondary-subtle rounded-1"
              id="district"
              name="district"
              onChange={handleChange}
              required
            />
          </div>

          <div className="mt-4">
            <label
              className="mb-1"
              htmlFor="lastEducationQualification">
              Last Education Qualification
            </label>

            <textarea
              className="form-control border-secondary-subtle rounded-1"
              id="lastEducationQualification"
              name="lastEducationQualification"
              onChange={handleChange}
            />
          </div>

          <div className="row">
            <div className="col-sm-6 mt-4">
              <label
                className="mb-1"
                htmlFor="permanentAddress">
                Permanent Address
              </label>

              <textarea
                className="form-control border-secondary-subtle rounded-1"
                id="permanentAddress"
                name="permanentAddress"
                onChange={handleChange}></textarea>
            </div>

            <div className="col-sm-6 mt-4">
              <label
                className="mb-1"
                htmlFor="presentAddress">
                Present Address
              </label>

              <textarea
                className="form-control border-secondary-subtle rounded-1"
                id="presentAddress"
                name="presentAddress"
                onChange={handleChange}></textarea>
            </div>
          </div>
        </div>
      </div>

      <button
        disabled={uploading}
        type="submit"
        className="btn btn-success float-end rounded-1 my-4">
        {uploading && (
          <div
            className="spinner-border spinner-border-sm me-2"
            role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        )}
        Submit
      </button>
    </form>
  );
};

export default Form;
